import { useEffect, useState } from 'react';
import { getOsmNames } from '../services/api.ts';

export function useOsmNames() {
  const [data, setData] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    async function load() {
      try {
        const result = await getOsmNames();
        setData(result);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  return { data, loading, error };
}
